import usePublisherRouteGuard from "../use-publisher-route-guard";

const GUIDE_STEPS = [
    { title: "Check your overview", body: "Your overview shows total earnings pending, your last payment received and the next expected payout." },
    { title: "Complete your KYC", body: "Head to the KYC tab and submit your PAN, Aadhaar and bank details. Payouts stay locked until verification clears." },
    { title: "Track earnings by brand", body: "The Earnings tab breaks down every invoice period, brand and confirmation ID so you always know what's pending or paid." },
    { title: "Watch the KYC window", body: "Each brand mapping has a KYC window. If it lapses before verification completes, funds are held and returned to the brand." },
    { title: "Get paid automatically", body: "Once verified, payouts are released to your bank account on each brand's payout cycle — no further action needed." }
];

const PublisherGuide = () => {
    usePublisherRouteGuard();

    return (
        <div className="p-6">
            <div className="flex items-end justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Publisher user guide</h1>
                    <p className="text-sm text-muted">Complete your KYC, track earnings and confirm your payouts.</p>
                </div>
            </div>

            <ol className="mt-6 space-y-3">
                {GUIDE_STEPS.map((step, idx) => (
                    <li key={step.title} className="flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                        <div className="min-w-0">
                            <p className="text-[11px] font-semibold uppercase tracking-wider text-accent">Step {idx + 1}</p>
                            <p className="text-sm font-medium text-gray-900">{step.title}</p>
                            <p className="mt-1 text-sm text-muted">{step.body}</p>
                        </div>
                    </li>
                ))}
            </ol>
        </div>
    );
};

export default PublisherGuide;
